import React from "react";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import Button from "../../Core/Components/CustomButton";
import TrikeIcon from "../../Common/Svgs/TrikeIcon";

const NoHubStationModal = ({ visible, onCancel }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/add-hub");
    onCancel();
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<TrikeIcon className="fill-none text-white" />}
              background="bg-alert-red"
            />
          </div>

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Cannot add trike
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            Please add a{" "}
            <span className="underline cursor-pointer" onClick={handleClick}>
              hub station
            </span>{" "}
            to continue.
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default NoHubStationModal;
